interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
              SmartDevices?: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink: string;
          };
}

export const emailMap: IEmailMap = {
    us: {
        type: 'klaviyo',
        list_id: 'R7UBhC',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'XnGjwe',
        popupBtnLink: 'https://us.ecoflow.com/products/wave-2-extra-coupon',
    },
    ca: {
        type: 'klaviyo',
        list_id: 'Y8vT4G',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'VF3WM5',
        popupBtnLink: 'https://ca.ecoflow.com/products/wave-2-extra-coupon',
    },
    eu: {
        type: 'klaviyo',
        list_id: 'Ut9cAC',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'QYzW29',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    uk: {
        type: 'klaviyo',
        list_id: 'Tiz7J4',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'QPfTxH',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    de: {
        type: 'klaviyo',
        list_id: 'S5qJLr',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'SapZ8J',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowclubdeutsch?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    },
    fr: {
        type: 'klaviyo',
        list_id: 'WXpBdT',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'Wsyj4h',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowfrancophone?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    },
    it: {
        type: 'klaviyo',
        list_id: 'Rtmcay',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'Xe88hm',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    es: {
        type: 'klaviyo',
        list_id: 'Y2KFBF',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'UBwriq',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    jp: {
        type: 'mailchimp',
        action: 'https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=440b6cbd62&amp;f_id=00b372e1f0',
        popupBtnLink: 'https://lin.ee/g7W0VbD',
    },
    au: {
        type: 'klaviyo',
        list_id: 'TjFhiD',
        source: 'EcoFlow WAVE2 Teaser from',
        consent_form_id: 'SABeet',
        popupBtnLink: 'https://www.facebook.com/groups/efaustralia/',
    },
};
